var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveAffirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Crown--Streamline-Flex",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Crown Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crown--reward-social-rating-media-queen-vip-king-crown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.959867 3.73147c0.017238 -0.16112 0.217403 -0.20062 0.309593 -0.06736L2.81337 5.896c0.42676 0.61693 1.35565 0.56175 1.70638 -0.10137l2.27082 -4.29348C6.83162 1.42355 6.91221 1.375 7 1.375s0.16838 0.04855 0.20943 0.12615l2.27082 4.29348c0.35073 0.66312 1.27965 0.7183 1.70635 0.10136l1.5439 -2.23188c0.0922 -0.13326 0.2924 -0.09376 0.3096 0.06736C13.1539 4.79498 13.25 5.88684 13.25 7c0 1.11315 -0.0961 2.20502 -0.2099 3.2685 -0.1541 1.4407 -1.3128 2.5994 -2.7528 2.7599 -1.06951 0.1192 -2.16767 0.2216 -3.2873 0.2216s-2.21779 -0.1024 -3.28734 -0.2216C2.2727 12.8679 1.114 11.7092 0.959867 10.2685 0.846084 9.20502 0.75 8.11315 0.75 7c0 -1.11316 0.096083 -2.20502 0.209867 -3.26853Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAffirmation);
export default __webpack_public_path__ + "static/media/active-affirmation.dd8ebae9ddd683d4f7ec35116ddeabe2.svg";
export { ForwardRef as ReactComponent };